module.exports = __webpack_public_path__ + "media/images/it/icons/medal-caded95705db8eff84da75078062486e.svg";